var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"head"},[_vm._v("恭喜您,入驻申请已经通过审核！")]),_vm._v(" "),_c('p',[_vm._v("欢迎您的加入")]),_vm._v(" "),_c('p',[_vm._v("立即体验七鸥鸥商家管理系统的更多功能")]),_vm._v(" "),_c('p',{staticClass:"body"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.home}},[_vm._v("立即体验")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ecd55dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register/AuditFinish.vue
// module id = null
// module chunks = 